import { SET_PROPERTY_FIELDS } from '../../../types';
import { calcPropertyOccupiedVacantSpace } from './postUpdate';
import { setPropMRepairMaintenace, setPropMInspection, setPropMLockboxInfo, setPropMViolation } from '../management';

export const FDIC_updateManagement = (event) => async(dispatch, getState) => {
    try {
    //  DESC:OCCUPANCY STATUS
        const { properties: { propertyFields } } = getState();
        //  DESC:Pre-defined an empty errors array
        const errors = [];

        //  DESC:Create new Property Fields Object and update it with new value
        let newPropertyFields = {
            ...propertyFields,
            [event.target.name]: event.target.value
        };

        //  DESC:Destructure necsserary values to use to update property fields
        //  DESC:Possible rename to use easier
        const {
            property_management_om_approval_date: om_approval_date,
            property_management_approval_for_3ppm,
            property_management_reason_for_3ppm
        } = newPropertyFields;

        //  DESC:Pre-defined Occupancy Status

        const Yes = 'Y';
        const No = 'N';
        const No_3PPM_Approval = 158;

        //  DESC:Checking for 3PPM Approval with No value
        //  DESC:set Approval Date to empty if status is No
        //  DESC:set Reason to No 3PPM Approval if status is No
        //  DESC:set Reason to empty if status is Yes
        if (property_management_approval_for_3ppm === No) {
            if (om_approval_date) {
                newPropertyFields.property_management_om_approval_date = '';
                errors.push('3PPM is not Approved. USMS Approval Date is removed.');
            }
            if (parseInt(property_management_reason_for_3ppm) !== No_3PPM_Approval) {
                newPropertyFields.property_management_reason_for_3ppm = No_3PPM_Approval;
                errors.push('3PPM is not Approved. Reason for 3PPM is set to "No 3PPM Approval".');
            }
        }
        else if (property_management_approval_for_3ppm === Yes) {
            if (parseInt(property_management_reason_for_3ppm) === No_3PPM_Approval) {
                newPropertyFields.property_management_reason_for_3ppm = '';
                errors.push('3PPM is Approved. Please pick a Reason for 3PPM.');
            }
        }

        switch (event.target.name) {
            case 'property_management_violations': {
            //  DESC:PROPERTY MANAGEMENT - MOST RECENT VIOLATION FIELDS
            //  DESC:Set violation values in properties table to recent one
            //  DESC:Parse the log into JSON object
                const ViolationLogs = JSON.parse(event.target.value);

                //  DESC:Select the latest log from the logs
                const LatestLog = ViolationLogs[ViolationLogs.length - 1];

                //  DESC:Destructure value from LastesLog
                //  DESC:And rename values
                const {
                    ['Notice Date']: violation_notice_date,
                    ['Status']: violation_status,
                    ['Reason']: violation_reason,
                    ['Noticing Entity']: violation_noticing_entity,
                    ['Remedy Start Date']: violation_remedy_start_date,
                    ['Remedy']: violation_remedy,
                    ['Description']: violation_description
                } = LatestLog;

                //  DESC:If LatestLog has value - update newPropertyFields with new values
                //  DESC:If not - Set them all to empty
                if (LatestLog) {
                    newPropertyFields = {
                        ...newPropertyFields,
                        violation_notice_date,
                        violation_status,
                        violation_reason,
                        violation_noticing_entity,
                        violation_remedy_start_date,
                        violation_remedy,
                        violation_description
                    };
                }
                else {
                    newPropertyFields = {
                        ...newPropertyFields,
                        violation_description: '',
                        violation_notice_date: '',
                        violation_status: '',
                        violation_reason: '',
                        violation_noticing_entity: '',
                        violation_remedy_start_date: '',
                        violation_remedy: ''
                    };
                }
                break;
            }
            case 'property_management_lockbox_info': {
            //  DESC: Logic for property_management_lockbox_info field.

                //  DESC: Take marketing_lockbox array and select the latest item in the array. Set newest lockbox code and lockbox description to regular fields.
                const marketingLockboxes = JSON.parse(event.target.value);
                const marketingLockbox = marketingLockboxes[marketingLockboxes.length - 1];

                // If there is no Code then remove from the fields
                if (marketingLockbox) {
                    const { Code, Description } = marketingLockbox;
                    newPropertyFields.marketing_lockbox_code = Code;
                    newPropertyFields.marketing_lockbox_description = Description;
                }
                else {
                    newPropertyFields.marketing_lockbox_code = '';
                    newPropertyFields.marketing_lockbox_description = '';
                }

                break;
            }
            default:
                break;
        }

        //  DESC:proceed to update value normally
        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
        //  DESC:Throw warning if there is any
        if (errors.length > 0) {
            //  @todo: handle error here
            // dispatch(setAlert(errors.toString(), 'info'));
        }
    }
    catch (error) {
        //  @todo: handle error here
        // dispatch(setAlert(error.message, 'error'));
    }
    finally {
        switch (event.target.name) {
            case 'property_management_violations':
                dispatch(setPropMViolation());
                break;
            case 'property_management_lockbox_info':
                dispatch(setPropMLockboxInfo());
                break;
            case 'property_management_inspections':
                dispatch(setPropMInspection());
                break;
            case 'property_management_maintenance_and_repairs':
                dispatch(setPropMRepairMaintenace());
                break;
            case 'property_management_leased_space':
                dispatch(calcPropertyOccupiedVacantSpace());
                break;
            default:
                break;
        }
    }
};